import { render, staticRenderFns } from "./SugestaoList.vue?vue&type=template&id=1ac4de28&scoped=true"
import script from "./SugestaoList.vue?vue&type=script&lang=js"
export * from "./SugestaoList.vue?vue&type=script&lang=js"
import style0 from "./SugestaoList.vue?vue&type=style&index=0&id=1ac4de28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac4de28",
  null
  
)

export default component.exports